<small class="debug">{{me}}</small>
<div [ngClass]="enterpriseMode ? 'globalStyle' : ''">
  <div style="width: 100%;">
    @if (_ready) {
      <div class="chartContainer">
        <highcharts-chart style="display: flex;" [callbackFunction]="chartCallback" [Highcharts]="Highcharts" [options]="chartOptions" (chartInstance)="logChartInstance($event)"></highcharts-chart>
      </div>
    }
    @if (!_ready) {
      <div>
        <app-loading [@fadeInOutAnimation] [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
      </div>
    }
  </div>
</div>
